<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-06-24 11:33:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:25:58
-->
<template>
  <div>
    <div v-if="$route.name == 'fileFirectory'">
      <mrc_ess_addBtn @handleAdd="handleAdd"></mrc_ess_addBtn>
      <mrc_ess_skeleton_loader :loading="skLoading">
        <v-card>
          <v-card-text class="px-8">
            <div class="text--secondary pb-3 pl-10">
              {{ $t("label_001-018_001-017-002_key_file_directory") }}
            </div>
            <template
              v-if="Array.isArray(companyList) && companyList.length > 0"
            >
              <v-treeview
                hoverable
                open-on-click
                selected-color="primary"
                transition
                item-key="uuid"
                item-children="children"
                expand-icon="arrow_drop_down"
                :items="companyList"
              >
                <template v-slot:label="{ item }">
                  {{ INT(item.directory_name) }}
                </template>
                <template v-slot:append="{ item }">
                  <menu-list
                    @handleClick="handleClick($event, item)"
                    :list="[
                      {
                        name: $t('label_View'),
                        type: 'view',
                        show: true,
                      },
                      {
                        name: $t('label_001-018_001-017-003_rename_key'),
                        type: 'edit',
                        show: true,
                      },
                      {
                        name: $t('label_delete'),
                        type: 'del',
                        show: true,
                      },
                    ]"
                  >
                    <template v-slot:showAction>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </template>
                  </menu-list>
                </template>
              </v-treeview>
              <mrc_ess_myDialog
                v-model="dialog"
                :title="$t('label_001-018_001-017-003_rename_key')"
                :width="400"
                @success="telsave"
                @cancel="telclose"
              >
                <input
                  id="renameText"
                  type="text"
                  :value="getFileName(renameobj)"
                  style="border: 1px solid #696969; width: 330px"
                />
              </mrc_ess_myDialog>
            </template>
            <template v-else>
              <mrc_ess_noContent></mrc_ess_noContent>
            </template>
          </v-card-text>
        </v-card>
      </mrc_ess_skeleton_loader>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { get_company_del } from "@/service/api/company_set";
import { file_tree } from "@/service/api/file";

export default {
  components: {},
  props: {},
  data() {
    return {
      renameobj: {},
      companyList: [],
      dialog: false,
      skLoading: false,
    };
  },
  async created() {
    await this.getBtnPermissionList();
  },
  async mounted() {
    if (this.$route.name == "fileFirectory") {
      await this.getList();
      this.skLoading = false;
    }
  },
  methods: {
    getFileName(obj) {
      return String(obj.file_name).replace("." + obj.file_type, "");
    },
    async telsave() {
      let renameText = document.getElementById("renameText").value;
      this.renameobj.file_name = renameText + "." + this.renameobj.file_type;
      var ok = await rename(this.renameobj);

      if (ok.code == 200) {
        this.renameobj = {};
        this.dialog = false;
        this.$Message({
          text: this.$t("message_The_operation_was_successful"),
        });
      }
    },
    telclose() {
      this.renameobj = {};
    },
    delData(uuid) {
      this.Recursion(this.companyList, uuid);
    },
    Recursion(arr, uuid) {
      if (arr.length <= 0) return "";
      arr.forEach((item, index) => {
        if (item.uuid == uuid) {
          arr.splice(index, 1);
        } else {
          if (item.children) {
            this.Recursion(item.children, uuid);
          }
        }
      });
    },
    // 获取公司列表
    async getList() {
      this.skLoading = true;
      var tree = await file_tree({
        org_level_uuid: this.$store.state.currentCompany,
        directory_type: 1,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      const list = tree;
      if (list.code == 200) {
        this.companyList = list.data ? list.data : [];
      }
      this.skLoading = false;
    },
    // 跳转添加公司页面
    handleAdd() {
      this.$router.push({
        name: "addFileDirectory",
      });
    },
    handleClick({ item, index }, obj) {
      switch (item.type) {
        case "view":
          this.$store.commit("set_subPage_name", obj.org_level_name);
          this.$store.commit("set_listObj", obj);
          this.$store.commit("set_uuid", obj.uuid);
          this.$store.commit("set_uuid2", obj.client_uuid);
          this.$store.commit("setOrgLevelCode", obj.org_level_code);
          this.$store.commit("set_iconstatus", true);
          this.$router.push({
            name: "enterpriseInfo",
            params: {
              name: obj.org_level_name,
              uuid: obj.uuid,
            },
          });
          break;
        case "edit":
          this.dialog = true;
          this.renameobj = obj;
          break;
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          })
            .then(async () => {
              const del = await get_company_del({ uuid: obj.uuid });
              if (del.code == 200) {
                this.delData(obj.uuid);
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                });
                if (
                  this.$store.state.userData.userType != 1 &&
                  this.$store.state.userData.userType != 4
                ) {
                  await this.$store.dispatch("set_topcompanylist");
                }
              }
            })
            .catch(() => {});
          break;
      }
    },
  },
  computed: {},
  watch: {
    async $route(val) {
      if (val.name == "fileFirectory") {
        await this.getList();
        this.$store.commit("setTab", 0);
      }
    },
  },
};
</script>

<style scoped>
/* /deep/ .v-treeview {
  border-bottom: 1px solid #e8e8e8;
  border-radius: 8px;
}
/deep/ .v-treeview-node__root {
  border: 1px solid #e8e8e8;
  border-bottom: none;
} */
/deep/ .v-treeview-node {
  margin-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 8px;
}
/* /deep/ .v-treeview {
  border-radius: 8px;
} */
/deep/ .v-treeview-node__root:first-of-type {
  border-radius: 8px;
}
/deep/ .v-treeview-node__root {
  border: 1px solid #e8e8e8;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom: none;
  height: 60px;
}
/deep/ .v-treeview-node__children .v-treeview-node,
/deep/ .v-treeview-node__children .v-treeview-node__root {
  border-bottom: none;
  margin-bottom: 0;
  border-radius: inherit;
}
/deep/
  .v-treeview-node__children:last-child
  .v-treeview-node:last-child
  .v-treeview-node__root:last-child {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
/deep/ .v-treeview-node__root:last-child {
  border-top-right-radius: inherit;
  border-top-left-radius: inherit;
}
</style>
